import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'

import PageTitle from '../controls/PageTitle'
import BreadcrumbContainer from '../controls/BreadcrumbContainer'
import LoadingStatus from '../controls/LoadingStatusContainer'
import CommunityDetailsView from './CommunityDetailsView'
import CommunityAlertsContainer from '../alerts/CommunityAlertsContainer'
import CommunityMapView from '../maps/CommunityMapView'
import CommunityChartContainer from './CommunityChartContainer'
import UnitListContainer from './UnitListContainer'
import CommunityAccessControlContainer from '../dooraccess/CommunityAccessControlContainer'
import { splitOn } from '../../utils/SplitIO'

import * as CommunityActionCreators from '../../actions/community'

class CommunityDetailsPage extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    /* mapped state */
    auth: PropTypes.object.isRequired,
    communities: PropTypes.object.isRequired,
    /* mapped dispatch */
    communityActions: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    gutters: {
      marginBottom: theme.spacing(2),
    },
  })

  static mapStateToProps(state) {
    return {
      auth: state.auth,
      communities: state.communities,
      units: state.units,
      unitsByCommunity: state.unitsByCommunity,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      communityActions: bindActionCreators(CommunityActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.props.communityActions.fetchCommunity(this.communityId())
  }

  communityId() {
    return parseInt(this.props.match.params.communityId, 10)
  }

  community() {
    const { communities } = this.props
    return communities[this.communityId()] || {}
  }

  render() {
    const community = this.community()
    const communityId = this.communityId()
    const communityName = community.name || communityId.toString()

    return (
      <>
        <PageTitle title={communityName} />
        <LoadingStatus />
        <BreadcrumbContainer items={[
          { title: communityName },
        ]}
        />

        <div className={this.props.classes.gutters}>
          <CommunityDetailsView community={community} />
        </div>

        <Grid container spacing={2} className={this.props.classes.gutters}>
          <Grid item xs={12} sm>
            <CommunityAlertsContainer communityId={communityId} />
          </Grid>
          <Grid item xs={12} sm>
            <CommunityMapView communities={{ [communityId]: community }} />
          </Grid>
        </Grid>

        <div className={this.props.classes.gutters}>
          <CommunityChartContainer communityId={communityId} />
        </div>

        <div className={this.props.classes.gutters}>
          <UnitListContainer communityId={communityId} />
        </div>

        { splitOn('access_control', this.props.auth, { community_id: communityId })
          && <CommunityAccessControlContainer communityId={communityId} />}
      </>
    )
  }
}

export default connect(
  CommunityDetailsPage.mapStateToProps,
  CommunityDetailsPage.mapDispatchToProps,
)(withStyles(CommunityDetailsPage.styles)(CommunityDetailsPage))
